import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const OfferBannerSection = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        :root {
          --cta-bg-img: url("https://html.themehour.net/kleanix/demo/assets/img/bg/cta-v4-bg.jpg");
          --cta-heading-font: "Archivo", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          --cta-body-font: "DM Sans", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          --cta-accent: #91e835;
          --cta-heading-color: #ffffff;
          --cta-body-color: #cbd5f5;
          --cta-radius: 56px;
          --cta-shadow: 0 30px 80px rgba(0, 0, 0, 0.7);
          --cta-btn-radius: 999px;
          --cta-btn-height: 54px;
          --cta-ease: cubic-bezier(0.16, 1, 0.3, 1);
        }

        .cta4-section {
          padding: 80px 80px;
          background-color: #ffffff;
        }

        .cta4-inner {
          position: relative;
          border-radius: var(--cta-radius);
          overflow: hidden;
          background-image: var(--cta-bg-img);
          background-size: cover;
          background-position: center;
          box-shadow: var(--cta-shadow);
        }

        .cta4-inner::before {
          content: "";
          position: absolute;
          inset: 0;
          background: rgba(6, 6, 10, 0.9);
          mix-blend-mode: multiply;
        }

        .cta4-shape {
          position: absolute;
          top: 0;
          bottom: 0;
          width: 330px;
          pointer-events: none;
          z-index: 1;
        }
        .cta4-shape--left { left: 0; }
        .cta4-shape--right { right: 0; }

        .cta4-content {
          position: relative;
          z-index: 2;
          padding: 70px 24px;
          text-align: center;
          color: var(--cta-heading-color);
        }

        .cta4-kicker-wrap {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 12px;
        }

        .cta4-kicker-line {
          width: 44px;
          height: 2px;
          border-radius: 999px;
          background: var(--cta-accent);
        }

        .cta4-kicker {
          font-family: var(--cta-body-font);
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 0.22em;
          text-transform: uppercase;
          color: var(--cta-accent);
        }

        .cta4-heading {
          font-family: var(--cta-heading-font);
          font-weight: 800;
          font-size: 36px;
          margin-bottom: 16px;
        }

        .cta4-body {
          font-family: var(--cta-body-font);
          font-size: 14px;
          line-height: 1.8;
          max-width: 640px;
          margin: 0 auto 24px;
          color: var(--cta-body-color);
        }

        /* DEALS LIST */
        .cta4-deals {
          max-width: 640px;
          margin: 0 auto 30px;
          text-align: left;
        }

        .cta4-deals h4 {
          font-size: 15px;
          font-weight: 700;
          margin-bottom: 12px;
          color: #ffffff;
        }

        .cta4-deals ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .cta4-deals li {
          font-family: var(--cta-body-font);
          font-size: 14px;
          color: var(--cta-body-color);
          margin-bottom: 10px;
          display: flex;
          gap: 10px;
          align-items: flex-start;
        }

        .cta4-deals li span {
          color: var(--cta-accent);
          font-size: 16px;
          line-height: 1;
        }

        .cta4-note {
          font-size: 12px;
          color: #a5b4fc;
          margin-top: 10px;
          text-align: center;
        }

        .cta4-buttons {
          display: flex;
          justify-content: center;
          gap: 24px;
          flex-wrap: wrap;
          margin-top: 30px;
        }

        .cta4-btn {
          min-width: 180px;
          height: var(--cta-btn-height);
          padding: 0 38px;
          border-radius: var(--cta-btn-radius);
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 0.05em;
          border: none;
          cursor: pointer;
          box-shadow: 0 22px 40px rgba(0, 0, 0, 0.65);
        }

        .cta4-btn--green {
          background: linear-gradient(180deg, #8cea3c 0%, #5ab829 100%);
          color: #ffffff;
        }

        .cta4-btn--yellow {
          background: linear-gradient(180deg, #ffd631 0%, #f7a514 100%);
          color: #111827;
        }

        .cta4-btn:hover {
          transform: translateY(-3px);
        }

        @media (max-width: 599px) {
          .cta4-section { padding: 60px 12px; }
          .cta4-heading { font-size: 24px; }
          .cta4-deals { text-align: left; }
        }
      `}</style>

      <Box component="section" className="cta4-section">
        <Box className="cta4-inner">
          <img
            src="https://html.themehour.net/kleanix/demo/assets/img/shape/cta-4-shape-left.svg"
            alt=""
            className="cta4-shape cta4-shape--left"
          />
          <img
            src="https://html.themehour.net/kleanix/demo/assets/img/shape/cta-4-shape-right.svg"
            alt=""
            className="cta4-shape cta4-shape--right"
          />

          <Box className="cta4-content">
            <Box className="cta4-kicker-wrap">
              <Box className="cta4-kicker-line" />
              <Typography className="cta4-kicker">
                MEMBER DISCOUNTS
              </Typography>
              <Box className="cta4-kicker-line" />
            </Box>

            <Typography component="h2" className="cta4-heading">
              Unlock Exclusive Member Savings!
            </Typography>

            <Typography component="p" className="cta4-body">
              Don&apos;t pay full price for major repairs. Join the club and
              instantly qualify for significant labour discounts.
            </Typography>

            {/* DEALS */}
            <Box className="cta4-deals">
              <h4>The Deals:</h4>
              <ul>
                <li>
                  <span>💰</span>
                  <div>
                    <strong>20% OFF New Installations</strong> – Save big on
                    labour for new Furnace or AC units.
                  </div>
                </li>
                <li>
                  <span>💰</span>
                  <div>
                    <strong>20% OFF Repairs</strong> – Discounted labour on Water
                    Heater repairs or replacements.
                  </div>
                </li>
              </ul>
              <div className="cta4-note">
                Note: Discounts valid for active Rite Home Pros members only.
              </div>
            </Box>

            {/* BUTTONS */}
            <Box className="cta4-buttons">
              <Button
                disableRipple
                className="cta4-btn cta4-btn--green"
                onClick={() => navigate("/membership")}
              >
                JOIN MEMBERSHIP
              </Button>
              <Button
                disableRipple
                className="cta4-btn cta4-btn--yellow"
                onClick={() => navigate("/contact-us")}
              >
                CONTACT US
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default OfferBannerSection;
